export default "__VITE_ASSET__CzFK7dIX__"